var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThinArrow = function SvgThinArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.414 18.828"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.414 9.414h-34",
    "data-name": "Line 59"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "m9.414 17.414-8-8",
    "data-name": "Line 60"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "m9.414 1.414-8 8",
    "data-name": "Line 61"
  }))));
};
export { SvgThinArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNS40MTQgMTguODI4Ij4KICA8ZyBkYXRhLW5hbWU9Ikdyb3VwIDg4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgIDxwYXRoIGRhdGEtbmFtZT0iTGluZSA1OSIgZD0iTTM1LjQxNCA5LjQxNGgtMzQiLz4KICAgIDxwYXRoIGRhdGEtbmFtZT0iTGluZSA2MCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgZD0iTTkuNDE0IDE3LjQxNGwtOC04Ii8+CiAgICA8cGF0aCBkYXRhLW5hbWU9IkxpbmUgNjEiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIGQ9Ik05LjQxNCAxLjQxNGwtOCA4Ii8+CiAgPC9nPgo8L3N2Zz4=";